import { render, staticRenderFns } from "./TaskAttachmentTd.vue?vue&type=template&id=c971bf92&scoped=true&"
import script from "./TaskAttachmentTd.vue?vue&type=script&lang=js&"
export * from "./TaskAttachmentTd.vue?vue&type=script&lang=js&"
import style0 from "./TaskAttachmentTd.vue?vue&type=style&index=0&id=c971bf92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c971bf92",
  null
  
)

export default component.exports